export class ContractSpacePeriodPackagePriceRoom {
  id: number | undefined
  active: boolean
  hours: number
  free: boolean
  discount: number
  totalPrice: object | null
  deskPrice: object | null
  dateCreated: Date | string
  spacePeriodPackagePrice: object | null

  constructor() {
    this.active = false
    this.hours = 0
    this.free = false
    this.discount = 0
    this.totalPrice = null
    this.deskPrice = null
    this.dateCreated = ''
    this.spacePeriodPackagePrice = null
  }
}
